import * as React from 'react';
const SvgIcon = props => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff" viewBox="0 -960 960 960">
      <path fill={props.fill || '#1D252D'} d="M140-140v-188.46h60V-200h128.46v60zm491.92 0v-60h128.46v-128.46h60V-140zM140-631.54V-820h188.46v60H200v128.46zm620.38 0V-760H631.92v-60h188.46v188.46z"></path>
    </svg>;
};
export default React.memo(SvgIcon);